var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChooseProductsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5781",
    "data-name": "Group 5781",
    transform: "translate(-552.375 -477)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_861",
    "data-name": "Ellipse 861",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(552.375 477)",
    fill: "#fff4cf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "gift-2--reward-box-social-present-gift-media-rating-bow",
    transform: "translate(567.512 492.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2,14.959V6.393H1.724v8.566A1.466,1.466,0,0,0,3.19,16.425H15.729A1.466,1.466,0,0,0,17.2,14.959Z",
    transform: "translate(0.402 2.573)",
    fill: "none",
    stroke: "#c9790f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2239",
    "data-name": "Vector 2239",
    d: "M7,16.426V6.391",
    transform: "translate(2.862 2.572)",
    fill: "none",
    stroke: "#c9790f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.862,5.258v.881A1.466,1.466,0,0,1,17.4,7.605H2.328A1.466,1.466,0,0,1,.862,6.139V5.258A1.466,1.466,0,0,1,2.328,3.792H17.4A1.466,1.466,0,0,1,18.862,5.258Z",
    transform: "translate(0 1.36)",
    fill: "none",
    stroke: "#c9790f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.929,5.152c0-1.283-1.5-4.277-3.742-4.277-3.653,0-2.322,4.277-.574,4.277",
    transform: "translate(0.934 0)",
    fill: "none",
    stroke: "#c9790f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7,5.152C7,3.869,8.5.875,10.742.875c3.653,0,2.322,4.277.574,4.277",
    transform: "translate(2.862 0)",
    fill: "none",
    stroke: "#c9790f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseProductsIcon);
export default __webpack_public_path__ + "static/media/chooseProductsIcon.47cf4c7db302130282521a7225dd3566.svg";
export { ForwardRef as ReactComponent };